// content/zones/zone1.ts — THE BROKEN GATE's zone mechanic.
//
// Zone 1's identity is "learn the grammar", and its rule-set is deliberately the
// baseline: nothing here changes how the world behaves. What it does own is the
// teaching voice — one line per room that names the choice the layout is asking.
// Zones 2-6 replace this file's body with real systems (flood, husks, darkness…).

import type { Room, RunCtx, ZoneMechanic } from '../../types'
import {
  ZONE1,
  ZONE1_ENEMIES,
  ZONE1_GENERATORS,
  ZONE1_PROJECTILES,
} from '../../data/zones/zone1'
import { registerZone, registerZoneContent } from '../../game/zones'

const ROOM_BARKS = [
  'One source. Cut it and the room goes quiet.',
  'Two sources, and only one of you.',
  'Three. One of them is behind iron — find who carries the key.',
]

export const zone1Mechanic: ZoneMechanic = {
  zoneId: 1,

  onZoneStart(ctx: RunCtx): void {
    ctx.bark('The Broken Gate. Everything below starts here.')
  },

  onRoomStart(ctx: RunCtx, room: Room): void {
    const line = ROOM_BARKS[Math.min(ROOM_BARKS.length - 1, room.index)]
    if (line) ctx.bark(line)
  },

  update(_ctx: RunCtx, _dt: number): void {
    // Baseline zone: no per-frame rule. Intentionally empty.
  },

  onZoneEnd(_ctx: RunCtx): void {},
}

registerZoneContent({
  enemies: ZONE1_ENEMIES,
  projectiles: ZONE1_PROJECTILES,
  generators: ZONE1_GENERATORS,
})
registerZone(ZONE1, zone1Mechanic)
